class FeaturedProducts extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  // Set up the KeenSlider carousel for a given section
  setupCarousel() {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.5,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 2,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3,
              spacing: 2,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4,
              spacing: 2,
            },
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this?.els.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('featured-products')) {
  customElements.define('featured-products', FeaturedProducts)
}
